export default __webpack_public_path__ + "static/tabs-importance-do-0c673890a5171b8add29690e9b340f7c.png";